import type { IntlShape } from 'react-intl';

// English copy in this flow puts the day first ("2 Nov 2026") whatever the region.
const toDayFirstLocale = (locale: string) =>
  locale.toLowerCase().startsWith('en') ? 'en-GB' : locale;

const formatDayFirst = (
  intl: IntlShape,
  cycleEnd: string,
  options: Intl.DateTimeFormatOptions
) =>
  new Intl.DateTimeFormat(toDayFirstLocale(intl.locale), {
    ...options,
    ...(intl.timeZone != null && { timeZone: intl.timeZone }),
  }).format(new Date(cycleEnd));

/** When complimentary usage ends, e.g. `2 Nov 2026`. */
export const formatComplimentaryTrialEndDate = (intl: IntlShape, cycleEnd: string) =>
  formatDayFirst(intl, cycleEnd, { day: 'numeric', month: 'short', year: 'numeric' });

/** A short date without the year, e.g. `2 Nov`. */
export const formatComplimentaryTrialEndDayMonth = (intl: IntlShape, cycleEnd: string) =>
  formatDayFirst(intl, cycleEnd, { day: 'numeric', month: 'short' });

/** When complimentary usage ends with its weekday, e.g. `Monday 2 Nov`. */
export const formatComplimentaryTrialEndWeekday = (intl: IntlShape, cycleEnd: string) =>
  formatDayFirst(intl, cycleEnd, { weekday: 'long', day: 'numeric', month: 'short' });
